import type { QuoteData, SeriesKeys } from "~types/types";
import type { TransformEntry } from "~types/i18n";

type QuoteTableData = keyof Omit<QuoteData, SeriesKeys>;

type DataFieldNameTransform = Partial<Record<QuoteTableData, TransformEntry>>;

const FUND_DATA_GEO: QuoteTableData[] = [
  "openPrice",
  "prevClose",
  "volume",
  "fundGeographicFocus",
  "dayRange",
  "fiftyTwoWeekRange",
];

const FUND_DATA_RETURN: QuoteTableData[] = [
  "openPrice",
  "prevClose",
  "totalReturn1Year",
  "totalReturnYtd",
  "dayRange",
  "fiftyTwoWeekRange",
];

export const DATA_FIELDS_BY_SECURITY_TYPE: Record<string, QuoteTableData[]> = {
  CEF: FUND_DATA_GEO,
  CUR: [
    "openPrice",
    "prevClose",
    "totalReturnYtd",
    "dayRange",
    "fiftyTwoWeekRange",
  ],
  CEFH: FUND_DATA_GEO,
  COM: ["openPrice", "prevClose", "volume", "dayRange", "fiftyTwoWeekRange"],
  ETP: FUND_DATA_GEO,
  EQT: [
    "openPrice",
    "prevClose",
    "volume",
    "marketCap",
    "dayRange",
    "fiftyTwoWeekRange",
  ],
  GOV: FUND_DATA_RETURN,
  IND: FUND_DATA_RETURN,
  INDS: FUND_DATA_RETURN,
  INDN: FUND_DATA_RETURN,
  INDF: [
    "openPrice",
    "prevClose",
    "totalReturnYtd",
    "dayRange",
    "fiftyTwoWeekRange",
  ],
  MMF: [
    "openPrice",
    "prevClose",
    "volume",
    "shareClass",
    "fundGeographicFocus",
    "dayRange",
    "fiftyTwoWeekRange",
  ],
  OEF: [
    "openPrice",
    "prevClose",
    "volume",
    "shareClass",
    "fundGeographicFocus",
    "dayRange",
    "fiftyTwoWeekRange",
  ],
};

export const DATA_FIELD_NAME_TRANSFORM: DataFieldNameTransform = {
  prevClose: { id: "prevClose", defaultMessage: "PREV. CLOSE" },
  marketCap: { id: "marketCap", defaultMessage: "MARKET CAP" },
  dayRange: { id: "dayRange", defaultMessage: "DAY RANGE" },
  fiftyTwoWeekRange: { id: "52WeekRange", defaultMessage: "52 WEEK RANGE" },
  openPrice: { id: "open", defaultMessage: "OPEN" },
  volume: { id: "volume", defaultMessage: "VOLUME" },
  totalReturnYtd: { id: "ytdReturn", defaultMessage: "YTD RETURN" },
  totalReturn1Year: { id: "1YearReturn", defaultMessage: "1 YEAR RETURN" },
  fundGeographicFocus: {
    id: "geographicFocus",
    defaultMessage: "GEOGRAPHIC FOCUS",
  },
  shareClass: { id: "shareClass", defaultMessage: "SHARE CLASS" },
};
